/* global G */
import find from 'lib/sequence/component/children/find'
import formatValue from 'app/_shared/component/formatValue'

export default module => component => async (...args) => {
  const { account } = module[G.MODEL][G.DATA]
  const { msgConfirmMD } = find(component)

  await formatValue(module, msgConfirmMD, { account }, 'text')

  return args
}
